/**
 * This is to wrap everything from '@klarna/bubble-ui',
 * enabling all apps use the same version of the library
 */
export * from '@klarna/bubble-ui'
